import { supabase } from './supabase';

// Create 15 diverse jobs across multiple industries for job discovery
const discoveryJobs = [
  {
    title: 'Marketing Coordinator',
    description: 'Support our marketing team in executing campaigns and managing social media. Help create engaging content and analyze campaign performance.',
    company: 'GrowthPath Marketing',
    location: 'Detroit, MI',
    remote: false,
    salary_min: 45000,
    salary_max: 60000,
    experience_level: 'entry',
    job_type: 'full_time',
    skills: ['Social Media', 'Content Creation', 'Marketing Analytics', 'Email Marketing', 'Canva'],
  },
  {
    title: 'Registered Nurse',
    description: 'Provide compassionate patient care in a fast-paced hospital environment. Work with a supportive team and access ongoing professional development.',
    company: 'Detroit Medical Center',
    location: 'Detroit, MI',
    remote: false,
    salary_min: 65000,
    salary_max: 85000,
    experience_level: 'mid',
    job_type: 'full_time',
    skills: ['Patient Care', 'Medical Records', 'Clinical Skills', 'Communication', 'Team Collaboration'],
  },
  {
    title: 'Financial Analyst',
    description: 'Analyze financial data and create reports to support business decisions. Work with cross-functional teams to drive financial performance.',
    company: 'Detroit Finance Group',
    location: 'Detroit, MI',
    remote: true,
    salary_min: 70000,
    salary_max: 95000,
    experience_level: 'mid',
    job_type: 'full_time',
    skills: ['Financial Modeling', 'Excel', 'Data Analysis', 'Forecasting', 'SQL'],
  },
  {
    title: 'Elementary School Teacher',
    description: 'Inspire young minds and create engaging learning experiences. Join a supportive school community dedicated to student success.',
    company: 'Detroit Public Schools',
    location: 'Detroit, MI',
    remote: false,
    salary_min: 48000,
    salary_max: 65000,
    experience_level: 'entry',
    job_type: 'full_time',
    skills: ['Classroom Management', 'Curriculum Development', 'Student Assessment', 'Communication', 'Patience'],
  },
  {
    title: 'Sales Representative',
    description: 'Build relationships with clients and drive revenue growth. Competitive commission structure with unlimited earning potential.',
    company: 'Midwest Sales Solutions',
    location: 'Remote',
    remote: true,
    salary_min: 55000,
    salary_max: 85000,
    experience_level: 'mid',
    job_type: 'full_time',
    skills: ['Sales', 'Customer Relations', 'CRM Software', 'Negotiation', 'Communication'],
  },
  {
    title: 'Graphic Designer',
    description: 'Create stunning visual designs for digital and print media. Work on diverse projects for exciting clients across industries.',
    company: 'Creative Studio Detroit',
    location: 'Detroit, MI',
    remote: true,
    salary_min: 50000,
    salary_max: 70000,
    experience_level: 'mid',
    job_type: 'full_time',
    skills: ['Adobe Creative Suite', 'Illustrator', 'Photoshop', 'Branding', 'Typography'],
  },
  {
    title: 'Warehouse Associate',
    description: 'Join our fast-paced distribution team. Benefits from day one including health insurance and 401k matching.',
    company: 'Detroit Logistics',
    location: 'Detroit, MI',
    remote: false,
    salary_min: 35000,
    salary_max: 45000,
    experience_level: 'entry',
    job_type: 'full_time',
    skills: ['Warehouse Operations', 'Forklift Operation', 'Inventory Management', 'Safety Compliance', 'Teamwork'],
  },
  {
    title: 'Human Resources Manager',
    description: 'Lead HR operations including recruitment, employee relations, and talent development. Shape company culture and drive organizational success.',
    company: 'TechVision Inc',
    location: 'Ann Arbor, MI',
    remote: true,
    salary_min: 75000,
    salary_max: 100000,
    experience_level: 'senior',
    job_type: 'full_time',
    skills: ['HR Management', 'Talent Acquisition', 'Employee Relations', 'HRIS', 'Performance Management'],
  },
  {
    title: 'Customer Service Representative',
    description: 'Help customers with inquiries and resolve issues. Great benefits, flexible schedule, and opportunities for advancement.',
    company: 'ServiceFirst Call Center',
    location: 'Remote',
    remote: true,
    salary_min: 32000,
    salary_max: 42000,
    experience_level: 'entry',
    job_type: 'full_time',
    skills: ['Customer Service', 'Problem Solving', 'Communication', 'CRM Software', 'Active Listening'],
  },
  {
    title: 'Software Developer',
    description: 'Build innovative web applications using modern technologies. Work in an agile environment with mentorship from senior developers.',
    company: 'Detroit Tech Solutions',
    location: 'Detroit, MI',
    remote: true,
    salary_min: 75000,
    salary_max: 105000,
    experience_level: 'mid',
    job_type: 'full_time',
    skills: ['JavaScript', 'React', 'Node.js', 'Git', 'Agile'],
  },
  {
    title: 'Physical Therapist',
    description: 'Help patients recover and improve mobility. Work in a modern facility with state-of-the-art equipment.',
    company: 'Detroit Rehabilitation Center',
    location: 'Detroit, MI',
    remote: false,
    salary_min: 70000,
    salary_max: 90000,
    experience_level: 'mid',
    job_type: 'full_time',
    skills: ['Physical Therapy', 'Patient Assessment', 'Treatment Planning', 'Documentation', 'Communication'],
  },
  {
    title: 'Administrative Assistant',
    description: 'Provide administrative support to executives and teams. Great entry point into a growing company with advancement opportunities.',
    company: 'Business Services Group',
    location: 'Detroit, MI',
    remote: false,
    salary_min: 38000,
    salary_max: 48000,
    experience_level: 'entry',
    job_type: 'full_time',
    skills: ['Microsoft Office', 'Scheduling', 'Data Entry', 'Communication', 'Organization'],
  },
  {
    title: 'Mechanical Engineer',
    description: 'Design and develop mechanical systems for automotive applications. Work on cutting-edge technology with industry-leading compensation.',
    company: 'Motor City Engineering',
    location: 'Detroit, MI',
    remote: false,
    salary_min: 80000,
    salary_max: 110000,
    experience_level: 'senior',
    job_type: 'full_time',
    skills: ['CAD Software', 'Mechanical Design', 'Prototyping', 'Testing', 'Project Management'],
  },
  {
    title: 'Restaurant Manager',
    description: 'Lead restaurant operations and create exceptional dining experiences. Competitive pay plus bonus incentives.',
    company: 'Detroit Dining Group',
    location: 'Detroit, MI',
    remote: false,
    salary_min: 50000,
    salary_max: 65000,
    experience_level: 'mid',
    job_type: 'full_time',
    skills: ['Restaurant Management', 'Staff Training', 'Inventory Control', 'Customer Service', 'P&L Management'],
  },
  {
    title: 'Data Analyst',
    description: 'Transform data into insights that drive business growth. Work with modern analytics tools and collaborate with stakeholders.',
    company: 'Analytics Pro',
    location: 'Remote',
    remote: true,
    salary_min: 65000,
    salary_max: 85000,
    experience_level: 'mid',
    job_type: 'full_time',
    skills: ['SQL', 'Python', 'Data Visualization', 'Excel', 'Tableau'],
  },
];

export async function seedJobsForDiscovery(employerId: string) {
  try {
    console.log('Seeding discovery jobs...');

    const jobsWithEmployer = discoveryJobs.map(job => ({
      ...job,
      employer_id: employerId,
      status: 'active',
    }));

    const { data, error } = await supabase
      .from('jobs')
      .insert(jobsWithEmployer)
      .select();

    if (error) {
      console.error('Error seeding discovery jobs:', error);
      return { success: false, error };
    }

    console.log(`✓ Successfully seeded ${data?.length || 0} discovery jobs`);
    return { success: true, jobs: data };
  } catch (error) {
    console.error('Error in seedJobsForDiscovery:', error);
    return { success: false, error };
  }
}

export async function createSystemEmployer() {
  try {
    console.log('Creating system employer profile...');

    // Check if system employer already exists
    const { data: existingProfile, error: checkError } = await supabase
      .from('profiles')
      .select('id')
      .eq('email', 'system@resuswipe.com')
      .maybeSingle();

    if (checkError) {
      console.error('Error checking for existing profile:', checkError);
      return { success: false, error: checkError };
    }

    if (existingProfile) {
      console.log('✓ System employer already exists:', existingProfile.id);
      return { success: true, employerId: existingProfile.id };
    }

    // Create auth user for system employer
    const { data: authData, error: authError } = await supabase.auth.signUp({
      email: 'system@resuswipe.com',
      password: 'SystemEmployer2024!SecurePassword',
      options: {
        data: {
          full_name: 'ResuSwipe System',
          role: 'employer',
        },
      },
    });

    if (authError) {
      console.error('Error creating auth user:', authError);
      return { success: false, error: authError };
    }

    const userId = authData.user?.id;
    if (!userId) {
      return { success: false, error: 'No user ID returned' };
    }

    // Create profile
    const { data: profileData, error: profileError } = await supabase
      .from('profiles')
      .insert({
        id: userId,
        role: 'employer',
        full_name: 'ResuSwipe System',
        email: 'system@resuswipe.com',
        company_name: 'ResuSwipe Demo Employers',
        bio: 'System account for seeding demo job postings',
      })
      .select()
      .single();

    if (profileError) {
      console.error('Error creating profile:', profileError);
      return { success: false, error: profileError };
    }

    console.log('✓ Created system employer profile:', profileData.id);
    return { success: true, employerId: profileData.id };
  } catch (error) {
    console.error('Error in createSystemEmployer:', error);
    return { success: false, error };
  }
}
